import React, { useState } from "react";
import { Sparkles, ArrowRight, Loader2 } from "lucide-react";
import api from "../lib/api";

const SAMPLE_QUERIES = [
  "Find a mason crew of 15+ in Pune under ₹800/day",
  "Need experienced steel fixers in Mumbai",
  "Painters with 4+ star rating in Bengaluru",
];

export default function SmartSearchBar({ onResults, variant = "hero" }) {
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function submit(e, override) {
    e?.preventDefault?.();
    const query = override ?? q;
    if (!query.trim()) return;
    setLoading(true);
    setError("");
    try {
      const res = await api.post("/ai/search", { query });
      onResults?.({ ...res.data, query });
    } catch (err) {
      setError("Smart search is busy. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  const isHero = variant === "hero";

  return (
    <div className={isHero ? "" : "border-2 border-slate-900 bg-white p-4"}>
      <form
        onSubmit={submit}
        className={`flex w-full items-stretch border-2 border-slate-900 bg-slate-900 ${isHero ? "shadow-brutal-lg" : ""}`}
      >
        <div className="flex items-center pl-4">
          <Sparkles className="h-5 w-5 text-safety-500" />
        </div>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search contractors, trades, sites…"
          data-testid="smart-search-input"
          className="min-w-0 flex-1 bg-slate-900 px-3 py-4 font-mono text-sm text-white placeholder:text-slate-500 focus:outline-none md:text-base"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="smart-search-submit"
          className="flex items-center gap-2 border-l-2 border-white/10 bg-safety-500 px-5 py-4 industrial-label text-slate-900 transition-colors hover:bg-safety-600 disabled:opacity-60"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ArrowRight className="h-4 w-4" />}
          {loading ? "Thinking" : "Search"}
        </button>
      </form>
      {error && <div className="mt-2 font-mono text-xs text-red-600">{error}</div>}
      {isHero && (
        <div className="mt-4 flex flex-wrap items-center gap-2">
          <span className="industrial-label text-slate-500">Try:</span>
          {SAMPLE_QUERIES.map((s) => (
            <button
              key={s}
              onClick={(e) => { setQ(s); submit(e, s); }}
              data-testid={`sample-query-${s.slice(0,8)}`}
              className="border border-slate-300 bg-white px-3 py-1 font-mono text-xs text-slate-700 transition-colors hover:border-slate-900 hover:bg-slate-50"
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
